import React from "react";
import { Button, Form, Input, Select, notification } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { languageLable, parseJwt } from "utilities/helpers";
import API from "api/api";

const { Option } = Select;
const api = new API();

export default function MobileEmailChange({
  contactMethod,
  handleClose,
  userData,
}) {
  const [form] = Form.useForm();
  const appState = useSelector((state) => state);
  const { selectedLanguageData } = appState?.app;
  const { countries } = appState?.auth;
  const dispatch = useDispatch();
  const { mobile, email, countrycode } = userData;

  const handleSubmit = async (values) => {
    let queryParams = new URLSearchParams();

    if (contactMethod === "both" || contactMethod === "mobile") {
      queryParams.append("phoneNumber", values.mobile);
      queryParams.append("isdCode", values.isdCode);
    }

    if (contactMethod === "both" || contactMethod === "email") {
      queryParams.append("email", values.email);
    }

    const payloadUrl = `updateEmailAndPhoneNumber?${queryParams.toString()}`;

    try {
      const response = await api.post(payloadUrl);

      if (response?.StatusCode === 200) {
        notification.success({
          message: "Details have been updated successfully.",
        });

        dispatch({
          type: "OPEN_EMAIL_PHONE_OPTION_MODAL",
          openEmailPhoneOptionModal: false,
        });

        if (response?.Result && !response?.IsError) {
          const token = response.Result;
          localStorage.setItem("authToken", token);
          const tokenData = parseJwt(token);
          localStorage.setItem("userData", JSON.stringify(tokenData));

          dispatch({
            type: "LOGIN_USER",
            authToken: token,
            userData: tokenData,
          });
        }
      } else {
        notification.error({
          message:
            response?.Message || "Failed to update details. Please try again.",
        });
      }
    } catch (error) {
      console.error("MobileEmailChange ~ handleSubmit:", error);
      notification.error({
        message: "An error occurred while updating details.",
      });
    } finally {
      handleClose();
    }
  };

  const isdCodeSelector = (
    <Form.Item name="isdCode" noStyle>
      <Select style={{ width: 120 }} showSearch optionFilterProp="children">
        {countries?.map((item) => (
          <Option key={item.phone_code} value={item.phone_code}>
            {item.phone_code} - {item.name}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );

  return (
    <Form
      form={form}
      onFinish={handleSubmit}
      layout="vertical"
      onValuesChange={() => form.validateFields()}
    >
      {(contactMethod === "both" || contactMethod === "mobile") && (
        <>
          <p>
            Current Mobile <strong>{`${countrycode} ${mobile}`}</strong>
          </p>
          <Form.Item
            name="mobile"
            label={languageLable(selectedLanguageData, "Mobile Number*")}
            rules={[
              {
                required: true,
                message: languageLable(
                  selectedLanguageData,
                  "Please enter mobile number."
                ),
              },
            ]}
          >
            <Input
              addonBefore={isdCodeSelector}
              placeholder="Enter mobile number"
            />
          </Form.Item>
        </>
      )}

      {(contactMethod === "both" || contactMethod === "email") && (
        <>
          <p>
            Current Email <strong>{`${email}`}</strong>
          </p>
          <Form.Item
            name="email"
            label={languageLable(selectedLanguageData, "Email Id*")}
            rules={[
              {
                type: "email",
                required: true,
                message: languageLable(
                  selectedLanguageData,
                  "Please enter a valid email."
                ),
              },
            ]}
          >
            <Input placeholder="Enter email" />
          </Form.Item>
        </>
      )}

      <Form.Item>
        <Button type="primary" htmlType="submit" className="text-right">
          Update
        </Button>
      </Form.Item>
    </Form>
  );
}
